<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') ||
                  '合同号/零售商PO/进口商PO/外运编号/BOOKING#/FCR NO/关单号 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              variant="outline-success"
              class="ml-2"
              v-if="allow('E')"
              @click="exportData()"
            >
              <i class="el-icon-folder-opened"></i>
              {{ $l('INDEX.btn_export') || '导出' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="950px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="mini" label-width="135px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_contractNo') || '合同号'">
              <el-input
                v-model.trim="form.custContractNo"
                clearable
                size="mini"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.table_label_production_order_retailer_po') ||
                  '零售商PO'
              "
            >
              <el-input v-model.trim="form.retailerPo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_importerPo') || '进口商PO'"
            >
              <el-input v-model.trim="form.importerPo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_shipmentNo') || '外运编号'">
              <el-input v-model.trim="form.contractNo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="'BOOKING#'">
              <el-input v-model.trim="form.bookingNumber" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'FCR NO'">
              <el-input v-model.trim="form.bookingNo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_customsNo') || '关单号'">
              <el-input v-model.trim="form.customsNo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'itemNo'">
              <el-input v-model.trim="form.item" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="'upcNo'">
              <el-input v-model.trim="form.upc" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_English_Name') || '英文名称'"
            >
              <el-input
                v-model.trim="form.orderGoodsNameEn"
                clearable
                size="mini"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_goodsColorEn') || '英文颜色'"
            >
              <el-input
                v-model.trim="form.orderGoodsColorEn"
                clearable
                size="mini"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_containerName') || '箱型'"
            >
              <el-input v-model.trim="form.containerName" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_containerNo') || '箱号'">
              <el-input v-model.trim="form.containerNo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_vessel_voyage') || '船名航次'"
            >
              <el-input v-model.trim="form.vessel" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.table_label_custName') || '客户'">
              <dict-select
                url="/master/common/dict/customerSelect"
                v-model="form.listCustCode"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_customer') ||
                    '请选择客户'
                "
                size="mini"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_endcustomer_name') || '终端客户'"
            >
              <dict-select
                url="/master/common/dict/customerSelect"
                v-model="form.listEndCustCode"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_customer') ||
                    '请选择客户'
                "
                size="mini"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_shipmentStartDate') ||
                    '客户最早交期'
                "
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.shipmentDateStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.shipmentDateEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_shipmentEndDate') ||
                    '客户最晚交期'
                "
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.shipmentEndDateStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.shipmentEndDateEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_deliveryDate') || '产装日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.bookDeliveryDateStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.bookDeliveryDateEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('INDEX.form_closingDate') || '开船日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.closingDateStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.closingDateEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_bookingDate') || '订舱日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.bookingDateStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.bookingDateEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_eta') || '到港日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.etaStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.etaEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_cfdDate') || '提交清关文件日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.cfdDateStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.cfdDateEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_pfdDate') || '提交付款文件日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.pfdDateStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.pfdDateEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_shipment_createDate') || '发运单创建日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="mini" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="mini" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>

    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :title="$l('INDEX.dialog_title_select_export_template') || '选择导出模版'"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: chooseTemplateOptions.params,
        checkUrl: chooseTemplateOptions.exportCheckUrl,
      }"
    />
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  createTimeEnd: dayjs().format('YYYY-MM-DD'),
  createTimeStart: dayjs()
    .subtract(1, 'month')
    .format('YYYY-MM-DD'),
}
import dayjs from 'dayjs'
import ChooseTemplate from '@/views/factory/transport/shipmentDetailQuery/components/choose-template'

export default {
  components: { ChooseTemplate },
  props: {
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      chooseTemplateOptions: {
        visible: false,
        templateGroup: '',
        exportCheckUrl: '',
        params: {},
      },
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      const { item, upc } = this.form
      this.form.upcNo = ''
      this.form.itemNo = ''
      if (item) {
        this.form.itemNo = `"identifyNo":"${item}","identifyCodeType":"Item"`
      }
      if (upc) {
        this.form.upcNo = `"identifyNo":"${upc}","identifyCodeType":"UPC"`
      }
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    exportData() {
      this.chooseTemplateOptions = {
        visible: true,
        templateGroup: 'shipment-factory-detailQuery',
        exportCheckUrl: '',
        params: { ...(this.form || {}) },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
